/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type CreatePayoutBodyMethod = typeof CreatePayoutBodyMethod[keyof typeof CreatePayoutBodyMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePayoutBodyMethod = {
  BANK_SWIFT: 'BANK_SWIFT',
  UNIONPAY: 'UNIONPAY',
  ALIPAY: 'ALIPAY',
} as const;
